import { Table } from 'antd'
import './Table.less'

export default Table
